<template>
  <div>
    <router-view></router-view>
    <div class="override-loading popup-loading" v-bind:style="{display: loading}"></div>
    <snowCss v-if="isDisplayChristmasTheme"></snowCss>
  </div>
</template>
<script>
  import main from './main.js'
  import snowCss from '../src/components/ChristmasThemeCSS'
  export default {
    name: 'app',
    components : {
      snowCss
    },
    data () {
      return {
        loading: 'none',
        showToast: true,
        isDisplayChristmasTheme : true
      }
    },
    mounted () {
      let vm = this
      this.$bus.$on('login_page',(errMessage) => {
        // Verify token is expired
        if ('token.no_longer_effective' === errMessage && vm.showToast) {
          vm.$toastr.error(main.$t(errMessage), main.$t('message.error'), {})
          vm.showToast = false;
          const refreshToastTime = 1000;
          setTimeout(() => {
            vm.showToast = true;
          }, refreshToastTime);
        }

        vm.$auth.logout({
          makeRequest: true,
          success: function (response) {
            vm.$Progress.finish()
          },
          error: function (error) {
            vm.$Progress.fail()
            console.log(error)
          },
          redirect: '/login'
        })
      })
      $('html').removeClass('md-theme-default');
    },
    created () {
      this.$bus.$on('loading', ($status) => {
        this.loading = $status
      })
      let theme = this.$session.get('theme')
      let isUseChristmasTheme = this.$store.getters.config.main.christmas_theme
      if(isUseChristmasTheme){
        if(theme === undefined || theme) {
          this.$session.set('theme',true)
          this.isDisplayChristmasTheme = true
        }else{
          this.isDisplayChristmasTheme = false
        }
      }else{
        this.isDisplayChristmasTheme = false
        this.$session.remove(theme)
      }
    },

    beforeDestroy: function () {
      this.$bus.$off('loading')
    }
  }
</script>

<style>
  /* Import Font Awesome Icons Set */
  @import '~flag-icon-css/css/flag-icon.min.css';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  /* Import Bootstrap Vue Styles */
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
</style>
<style lang="scss">
  // Import Main styles for this application
  @import './scss/style';
  @import './assets/css/main.css';
  @import './assets/css/daterangepicker.css';
  @import './assets/css/font-awesome-animation.css';
</style>



// WEBPACK FOOTER //
// src/App.vue